import { Tabs, TabList, Tab, TabPanel, TabPanels } from "@chakra-ui/react";

const TabComponent = ({
  tab1,
  tab2,
  tab1Content,
  tab2Content,
  padding,
  variant,
  isFitted,
}) => {
  return (
    <Tabs isFitted={isFitted} variant={variant}>
      <TabList>
        <Tab
          _selected={{
            color: "headline.600",
            borderBottomColor: "headline.600",
          }}
          fontSize={{ base: "30px", md: "35px" }}
        >
          {tab1}
        </Tab>
        <Tab
          _selected={{
            color: "headline.600",
            borderBottomColor: "headline.600",
          }}
          fontSize={{ base: "30px", md: "35px" }}
        >
          {tab2}
        </Tab>
      </TabList>
      <TabPanels>
        <TabPanel padding={padding}>{tab1Content}</TabPanel>
        <TabPanel padding={padding}>{tab2Content}</TabPanel>
      </TabPanels>
    </Tabs>
  );
};
export default TabComponent;
